import { bold, evisortBlue } from '../../../assets/shared-styles/general';

const styles = {
  tablesItem: {
    display: 'flex',
    flexGrow: '1',
    '&:not(:last-child)': {
      marginBottom: '16px',
    },
    '& > *': {
      width: '100%',
    },
    '& figure': {
      margin: 0,
    },
    '& table': {
      width: '100%',
      border: 'solid 1px rgba(0, 0, 0, 0.15)',
      borderRadius: '4px',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      backgroundColor: '#fafafa',
      tableLayout: 'fixed',
      boxShadow: '0 2px 4px 0 rgba(17, 17, 17, 0.05)',
      '& thead': {
        '& th': {
          border: 'solid 1px rgba(0, 0, 0, 0.1)',
          padding: '8px 12px',
          fontSize: '13px',
          fontWeight: bold,
        },
      },
      '& tbody': {
        fontSize: '14px',
        '& td, th': {
          border: 'solid 1px rgba(0, 0, 0, 0.1)',
          padding: '8px 12px',
        },
        '& tr:not(:last-child) td': {
          borderBottom: 'solid 1px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
  horizontalSeparator: {
    '&:not(:last-child)': {
      height: '24px',
    },
  },
  tableActionLinks: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: '4px',
    },
  },
  tableActionLink: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: evisortBlue,
    fontSize: '13px',
    fontWeight: bold,
    '&:not(:last-child)': {
      marginRight: '16px',
    },
  },
};

export default styles;
